import { mapProfileFromDto } from '@entities/profile';

import { type Credentials } from '../models';
import { type CredentialsDto } from '../dto';

export function mapCredentialsFromDto(dto: CredentialsDto): Credentials {
  return {
    token: {
      key: dto.token.key,
      accessExpiresAt: new Date(dto.token.access_expires_at),
      refreshExpiresAt: new Date(dto.token.refresh_expires_at),
    },
    profile: mapProfileFromDto(dto.user),
  };
}
